import { animateUILoading } from './ui_loader.js';

const kSpinnerTimeout = 700;

/**
 * Blocks UI until the given promise is fullfilled.
 */
const UIBlocker = promise => {
  window.document.body.setAttribute('busy', 'busy');
  animateUILoading(window.document.body, promise, kSpinnerTimeout);
  return promise.finally(() => {
    window.document.body.removeAttribute('busy');
  });
};

export { UIBlocker };
